import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { isPDPUrl } from 'utils/product';
import Stars from '@johnlewispartnership/wtr-ingredients/ingredients/StarRating';
import styles from 'components/StarRating/StarRating.scss';

const starRatingDefaultPropClickHandler = () => {};

const StarRating = ({
  averageRating = 0,
  clickHandler = starRatingDefaultPropClickHandler,
  hasSchema = true,
  isSizeSmall = false,
  lighter = false,
  linkTo,
  reviewCount = 0,
  productName,
}) => {
  const baseProps = {
    className: classNames(styles.starRating, {
      [styles.isSizeSmall]: isSizeSmall,
      [styles.lighter]: lighter,
    }),
  };

  const wrapperProps = {
    ...baseProps,
    onClick: event => clickHandler(event),
  };

  const ratingText = isSizeSmall
    ? `(${reviewCount})`
    : `${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'}`;

  const content = (
    <>
      {productName ? <span className="sr-only">Read reviews for {productName}:&nbsp;</span> : null}
      <Stars
        rating={averageRating}
        hasSchema={hasSchema}
        starSize={isSizeSmall ? 'xsmall' : 'small'}
      />
      <span className={styles.ratingText}>
        {ratingText}{' '}
        {isSizeSmall ? (
          <span className="sr-only">{reviewCount === 1 ? 'review' : 'reviews'}</span>
        ) : null}
      </span>
    </>
  );

  return isPDPUrl(linkTo) ? (
    <a href={linkTo} {...wrapperProps}>
      {content}
    </a>
  ) : (
    <Link to={linkTo} {...wrapperProps}>
      {content}
    </Link>
  );
};

StarRating.displayName = 'StarRating';

StarRating.propTypes = {
  averageRating: PropTypes.number,
  clickHandler: PropTypes.func,
  hasSchema: PropTypes.bool,
  isSizeSmall: PropTypes.bool,
  lighter: PropTypes.bool,
  linkTo: PropTypes.string,
  reviewCount: PropTypes.number,
  productName: PropTypes.string,
};

export default memo(StarRating);
